export default __webpack_public_path__ + "img/fvxmHHcB.80fa646f.svg";